'use client'
import { MegaInfoCardType } from '@/types'
import Link from 'next/link'
import React from 'react'
import { useModal } from '../Modal/Modal'
import { ManagerFeedbackForm } from '../catalog/ManagerFeedbackForm'

interface Props {
    type: string
    item: MegaInfoCardType
    sendManager?: any
}

const MegaInfoCard: React.FC<Props> = ({ item, type, sendManager }) => {
    const [modal, setModal] = useModal()
    return (
        <div className='megaschool__info'>
            <div className='megaschool__info-top'>
                <p className='megaschool__card-tag categories-slider__text'>{item.tag}</p>
                <h3 className='megaschool__card-title'>{item.title}</h3>
                <p className='megaschool__info-text'>{item.text}</p>
            </div>
            <div className='megaschool__info-buttons'>
                {type !== 'managers' ? (
                    <Link
                        target='_blank'
                        style={{ display: 'contents' }}
                        href={
                            type === 'megaschool'
                                ? 'https://vkvideo.ru/playlist/-206668550_1'
                                : ''
                        }
                    >
                        <button
                            className='megaschool__info-btn'
                            onClick={
                                type === 'megaschool'
                                    ? () =>
                                          setModal(
                                              <ManagerFeedbackForm
                                                  manager={{
                                                      image: `${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${sendManager?.photo}`,
                                                      post: sendManager?.post,
                                                      name: sendManager?.name.replace('<br/>', ' '),
                                                      id: sendManager?.id,
                                                      email: sendManager?.email
                                                  }}
                                                  product={`Страница: Для фермеров`}
                                              />
                                          )
                                    : null
                            }
                        >
                            {type === 'megaschool' && (
                                <svg
                                    width='20'
                                    height='20'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M4.8 16.4755V3.60533C4.8 3.06572 5.3848 2.72903 5.85146 2.99996L17.2916 9.64178C17.7637 9.91588 17.7543 10.6009 17.2748 10.8619L5.83471 17.0903C5.36826 17.3442 4.8 17.0066 4.8 16.4755Z'
                                        stroke='#83A3EB'
                                        strokeWidth='1.6'
                                        strokeLinejoin='bevel'
                                    />
                                </svg>
                            )}
                            {type === 'megatravel' && (
                                <svg
                                    width='20'
                                    height='16'
                                    viewBox='0 0 20 16'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M1 13.1059V3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V13.1059C19 14.2104 18.1046 15.1059 17 15.1059H3C1.89543 15.1059 1 14.2104 1 13.1059Z'
                                        stroke='#83A3EB'
                                        strokeWidth='1.6'
                                    />
                                    <path
                                        d='M1 3.5L9.8829 9.91543C9.9528 9.96591 10.0472 9.96591 10.1171 9.91543L19 3.5'
                                        stroke='#83A3EB'
                                        strokeWidth='1.6'
                                    />
                                </svg>
                            )}
                            <p>{item.btnText}</p>
                        </button>
                    </Link>
                ) : (
                    <button
                        className='megaschool__info-btn'
                        onClick={
                            type === 'managers'
                                ? () =>
                                      setModal(
                                          <ManagerFeedbackForm
                                              manager={{
                                                  image: `${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${sendManager?.photo}`,
                                                  post: sendManager?.post,
                                                  name: sendManager?.name,
                                                  id: sendManager?.id,
                                                  email: sendManager?.email
                                              }}
                                              product={`Страница: Для фермеров`}
                                          />
                                      )
                                : null
                        }
                    >
                        <p>{item.btnText}</p>
                    </button>
                )}
                <Link
                    target='_blank'
                    style={{ display: 'contents' }}
                    href={
                        type === 'megaschool'
                            ? 'https://megakorm.ru/'
                            : 'https://youtube.com/playlist?list=PLS3UefXHHjQ4-1acdz-oBvzyy1XPbdspR&feature=shared'
                    }
                >
                    {type !== 'managers' ? (
                        <button className='megaschool__info-btn megaschool__info-btn_orange'>
                            {type === 'megaschool' && (
                                <svg
                                    width='20'
                                    height='20'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <circle
                                        cx='10'
                                        cy='10'
                                        r='9.2'
                                        stroke='#FEC2BA'
                                        strokeWidth='1.6'
                                    />
                                    <path
                                        d='M13.2 10C13.2 12.6857 12.7631 15.0803 12.0856 16.774C11.746 17.623 11.3616 18.2564 10.9757 18.6645C10.5914 19.0708 10.2614 19.2 10 19.2C9.73857 19.2 9.40857 19.0708 9.02426 18.6645C8.63836 18.2564 8.25397 17.623 7.91435 16.774C7.2369 15.0803 6.8 12.6857 6.8 10C6.8 7.3143 7.2369 4.91969 7.91435 3.22604C8.25397 2.377 8.63836 1.7436 9.02426 1.33554C9.40857 0.929164 9.73857 0.8 10 0.8C10.2614 0.8 10.5914 0.929164 10.9757 1.33554C11.3616 1.7436 11.746 2.377 12.0856 3.22604C12.7631 4.91969 13.2 7.3143 13.2 10Z'
                                        stroke='#FEC2BA'
                                        strokeWidth='1.6'
                                    />
                                    <line
                                        x1='1'
                                        y1='10.2'
                                        x2='19'
                                        y2='10.2'
                                        stroke='#FEC2BA'
                                        strokeWidth='1.6'
                                    />
                                </svg>
                            )}
                            {type === 'megatravel' && (
                                <svg
                                    width='21'
                                    height='20'
                                    viewBox='0 0 21 20'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M5.3 16.4755V3.60533C5.3 3.06572 5.8848 2.72903 6.35146 2.99996L17.7916 9.64178C18.2637 9.91588 18.2543 10.6009 17.7748 10.8619L6.33471 17.0903C5.86826 17.3442 5.3 17.0066 5.3 16.4755Z'
                                        stroke='#FEC2BA'
                                        strokeWidth='1.6'
                                        strokeLinejoin='bevel'
                                    />
                                </svg>
                            )}
                            <p>{item.btnTextOrange}</p>
                        </button>
                    ) : null}
                </Link>
            </div>
        </div>
    )
}

export default MegaInfoCard
